var header = {
  lastScroll: 0,
  ticking: false,

  init: function () {
    var closeBtn = document.querySelector(".info-bar__close");
    var infoBar = document.querySelector(".info-bar");
    if (closeBtn && infoBar) {
      closeBtn.addEventListener("click", function () {
        infoBar.classList.add("info-bar__hidden");
      });
    }

    // Mobile menu toggle
    var mobileMenuToggle = document.querySelectorAll(".js-mobile-menu-toggle");
    var mobileMenu = document.getElementById("mobile-menu");
    if (mobileMenuToggle && mobileMenu) {
      mobileMenuToggle.forEach(function (toggle) {
        toggle.addEventListener("click", function (e) {
          e.preventDefault();
          mobileMenu.classList.toggle("visible");
        });
      });

      // Přidání event listeneru pro kliknutí mimo menu
      document.addEventListener("click", function (e) {
        if (
          mobileMenu.classList.contains("visible") &&
          !mobileMenu.contains(e.target) &&
          !e.target.closest(".js-mobile-menu-toggle")
        ) {
          mobileMenu.classList.remove("visible");
        }
      });
    }

    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener("scroll", this.handleScroll);
    var headerEl = document.getElementById("header");
    if (headerEl) {
      headerEl.classList.add("header--full");
    }
  },

  handleScroll: function () {
    var self = this;
    var headerEl = document.getElementById("header");
    if (!headerEl) return;

    var currentScroll =
      window.pageYOffset || document.documentElement.scrollTop;

    if (currentScroll > self.lastScroll && currentScroll > 100) {
      headerEl.classList.add("header--compact");
      headerEl.classList.remove("header--full");
    } else {
      headerEl.classList.add("header--full");
      headerEl.classList.remove("header--compact");
    }

    self.lastScroll = currentScroll <= 0 ? 0 : currentScroll;
  },
};

export { header };
